import { render, staticRenderFns } from "./BillOrder.vue?vue&type=template&id=7f4a472d"
import script from "./BillOrder.vue?vue&type=script&lang=js"
export * from "./BillOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports